import React from "react";

function TermsConditions() {
  return (
    <div className="bg-background min-h-screen">
      <div className="max-w-5xl mx-auto px-6 py-20">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Terms & Conditions
        </h1>

        <p className="text-muted-foreground mb-10">
          <strong>Effective Date:</strong> July 2026
        </p>

        <section className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold mb-3">Welcome</h2>
            <p className="text-muted-foreground leading-8">
              Welcome to <strong>Dataviqu</strong>. These Terms & Conditions
              govern your access to and use of our website and services. By
              using our website or engaging our services, you agree to these
              terms. If you do not agree, please discontinue use of our website.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Our Services</h2>

            <p className="text-muted-foreground mb-4">
              Dataviqu provides professional technology and business services,
              including but not limited to:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Artificial Intelligence (AI) Solutions</li>
              <li>Machine Learning Solutions</li>
              <li>Data Analytics</li>
              <li>SQL Development</li>
              <li>Data Visualization</li>
              <li>Business Intelligence</li>
              <li>Cloud Solutions & Infrastructure</li>
              <li>Full-Stack Development</li>
              <li>Financial Analysis</li>
              <li>Business Analysis</li>
              <li>Forecasting & Strategic Planning</li>
              <li>Brand Identity Design</li>
              <li>Logo Design</li>
              <li>UI/UX Design</li>
              <li>Social Media Design</li>
            </ul>

            <p className="text-muted-foreground mt-4 leading-8">
              We reserve the right to modify, suspend, or discontinue any
              service at our discretion.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">
              Client Responsibilities
            </h2>

            <p className="text-muted-foreground mb-4">
              Clients agree to:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Provide accurate project requirements.</li>
              <li>
                Supply all necessary information, documents, and credentials.
              </li>
              <li>Respond to communications in a timely manner.</li>
              <li>
                Ensure that all submitted content complies with applicable laws
                and does not infringe on third-party rights.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Payments</h2>

            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Quotations are valid for 30 days unless otherwise specified.</li>
              <li>Some projects require an advance payment before work begins.</li>
              <li>Remaining payments must follow the agreed payment schedule.</li>
              <li>Delayed payments may result in suspension of services.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Project Delivery</h2>

            <p className="text-muted-foreground mb-4">
              Delivery timelines are estimates based on the agreed project
              scope.
            </p>

            <p className="text-muted-foreground mb-3">
              Project timelines may change due to:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Delayed client approvals</li>
              <li>Additional change requests</li>
              <li>Missing project information</li>
              <li>Circumstances beyond our reasonable control</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Revisions</h2>

            <p className="text-muted-foreground leading-8">
              Minor revisions are included unless otherwise agreed. Requests
              outside the agreed scope may incur additional charges.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">
              Intellectual Property
            </h2>

            <p className="text-muted-foreground leading-8">
              Upon full payment, clients receive ownership of the final approved
              deliverables. Dataviqu retains ownership of its proprietary
              frameworks, reusable code, templates, methodologies, and internal
              tools.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Confidentiality</h2>

            <p className="text-muted-foreground leading-8">
              Dataviqu treats all client information as confidential and will
              not disclose it without permission unless required by law.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">
              Limitation of Liability
            </h2>

            <p className="text-muted-foreground mb-4">
              Dataviqu shall not be liable for:
            </p>

            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Indirect or consequential damages</li>
              <li>Loss of profits</li>
              <li>Business interruption</li>
              <li>Data loss</li>
              <li>Third-party service failures</li>
            </ul>

            <p className="text-muted-foreground mt-4 leading-8">
              Our total liability shall not exceed the amount paid by the client
              for the specific service.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Termination</h2>

            <p className="text-muted-foreground leading-8">
              Either party may terminate a project through written notice.
              Completed work remains payable.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Governing Law</h2>

            <p className="text-muted-foreground leading-8">
              These Terms & Conditions shall be governed by the laws of India.
            </p>
          </div>

          <div className="border-t pt-8">
            <h2 className="text-2xl font-semibold mb-3">Contact</h2>

            <p className="text-muted-foreground">
              Email:{" "}
              <a
                href="mailto:contact@dataviqu.com"
                className="text-primary hover:underline"
              >
                contact@dataviqu.com
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TermsConditions;